import dayjs from "dayjs";

export const combinarFechasHora = ({fecha, fechaHora}) => {

    let fechaH = new Date(fechaHora)
    let fechaJ = dayjs(fecha).hour(fechaH.getHours()).minute(fechaH.getMinutes());

    return fechaJ.valueOf()

}